<template>
<div class="home" >
  <div class="popup" :class="{ hidden: is_hidden }" @click="toggleHidden()">
    <div class="popup_content">
      <img :src="image"/>
      <p>
        Clic droit > Enregistrer l'image sous pour obtenir l'image avec les propriétés suivantes :<br />
        rvb 72dpi 512px*512px
      </p>
    </div>
  </div>
  <div class=" home_content container">
    <h1>Accès aux ressources : Logos ESIPE</h1>
    <div class="banner row">      
      <div class="col-md-2 col-sm-2 col-xs-4" @click="toggleHidden('/static/ressources/eisc_rvb_numerique_petit.png')">
        <img src="/static/ressources/eisc_rvb_numerique_petit.png"/>
      </div>
      <div class="col-md-2 col-sm-2 col-xs-4" @click="toggleHidden('/static/ressources/gc_rvb_numerique_petit.png')">
        <img src="/static/ressources/gc_rvb_numerique_petit.png" />
      </div>
      <div class="col-md-2 col-sm-2 col-xs-4" @click="toggleHidden('/static/ressources/gm_rvb_numerique_petit.png')">
        <img src="/static/ressources/gm_rvb_numerique_petit.png" />
      </div>
      <div class="col-md-2 col-sm-2 col-xs-4" @click="toggleHidden('/static/ressources/imac_rvb_numerique_petit.png')">
        <img src="/static/ressources/imac_rvb_numerique_petit.png" />
      </div>
      <div class="col-md-2 col-sm-2 col-xs-4" @click="toggleHidden('/static/ressources/info_rvb_numerique_petit.png')">
        <img src="/static/ressources/info_rvb_numerique_petit.png" />
      </div>
      <div class="col-md-2 col-sm-2 col-xs-4" @click="toggleHidden('/static/ressources/mfpi_rvb_numerique_petit.png')">
        <img src="/static/ressources/mfpi_rvb_numerique_petit.png" />
      </div>
    </div>
    <div class="pack">
      <h2>Packs de logos prêt à l'emploi</h2>
      <p>
        Cliquez sur le pack qui vous convient. Un dossier compressé (.zip) contenant les fichiers vous sera fourni.
      </p>
      <a href="/static/packs/LogoEsipePackNumerique.zip" download="LogoEsipePackNumerique">
      <div class="col-md-4 col-sm-4 col-xs-4 col-sm-4 download_block pack">
        <h3>Pack Numérique</h3>
        <i class="fa fa-5x fa-link" aria-hidden="true"></i>
        <p>
        Contient les fichiers .PNG 72 dpi pour les documents numériques.       
        </p>
      </div>
      </a>
      <a href="/static/packs/LogoEsipePackPrint.zip" download="LogoEsipePackPrint">
      <div class="col-md-4 col-sm-4 col-xs-4 col-sm-4 download_block pack">
        <h3>Pack Print</h3>
        <i class="fa fa-5x fa-paperclip" aria-hidden="true"></i>
        <p>
        Contient les fichiers .EPS pour les 
        documents destinés à l'impression.       
        </p>
      </div>
      </a>
      <a href="/static/packs/LogoEsipePackComplet.zip" download="LogoEsipePackComplet">
      <div class="col-md-4 col-sm-4 col-xs-4 col-sm-4 download_block pack">
        <h3>Pack complet</h3>
        <i class="fa fa-5x fa-star" aria-hidden="true"></i>
        <p>
        Contient l'ensemble des ressources disponibles.
        </p>
      </div>
      </a>
    </div>
    <div class="custom">
      <h2>Aucun pack ne vous convient ? Créez le vôtre !</h2>
      <p>
      Cliquez sur les options qui vous conviennent.
      Un pack vous sera proposé en téléchargement.
      <br />
      Laissez un champ sans sélection s'il n'est
      n'est pas important pour vous. 
      Le pack contiendra l'option par défaut.
      </p>
      <h3>Formation ESIPE</h3>
      <div id="eisc" class="col-md-2 col-sm-2 col-xs-2  download_block" @click="handler(0,'eisc',0,'eisc')">
        <p>EISC</p>
      </div>
      <div id="gm" class="col-md-2 col-sm-2 col-xs-2  download_block" @click="handler(0,'gm',1,'gm')">
        <p>GM</p>
      </div>
      <div id="gc" class="col-md-2 col-sm-2 col-xs-2  download_block" @click="handler(0,'gc',2,'gc')">
        <p>GC</p>
      </div>
      <div id="imac" class="col-md-2 col-sm-2 col-xs-2  download_block" @click="handler(0,'imac',3,'imac')">
        <p>IMAC</p>
      </div>
      <div id="info" class="col-md-2 col-sm-2 col-xs-2  download_block" @click="handler(0,'info',4,'info')">
        <p>INFO</p>
      </div>
      <div id="mfpi" class="col-md-2 col-sm-2 col-xs-2  download_block" @click="handler(0,'mfpi',5,'mfpi')">
        <p>MFPI</p>
      </div>

      <h3>Couleur</h3>
      <div id="rvb" class="col-md-3 col-sm-3 col-xs-3  download_block" @click="handler(1,'rvb',0,'rvb')">
        <p>RVB <span>(numérique)</span></p>
      </div>
      <div id="cmjn" class="col-md-3 col-sm-3 col-xs-3  download_block" @click="handler(1,'cmjn',1,'cmjn')">
        <p>CMJN <span>(print)</span></p>
      </div>
      <div id="gris" class="col-md-3 col-sm-3 col-xs-3  download_block" @click="handler(1,'gris',2,'gris')">
        <p>Niveau de gris</p>
      </div>
      <div id="blanc" class="col-md-3 col-sm-3 col-xs-3  download_block" @click="handler(1,'blanc',3,'blanc')">
        <p>Blanc</p>
      </div>

      <h3>Support</h3>
      <div id="print" class="col-md-6 col-sm-6 col-xs-6  col-sm-6 download_block" @click="handler(2,'print',0,'print')">
        <p>
        Print <br /> <span>(.eps 300dpi)</span>
        </p>
      </div>
      <div id="numerique" class="col-md-6 col-sm-6 col-xs-6  download_block" @click="handler(2,'numerique',1,'numerique')">
        <p>
        Numérique <br /> <span>(.png 72dpi)</span>
        </p>
      </div>
      
      <h3>Taille</h3>
      <div id="grand" class="col-md-4 col-sm-4 col-xs-4 download_block" @click="handler(3,'grand',0,'grand')">
        <p>Grand <br /> <span>({{size_grand}})</span></p>
      </div>
      <div id="moyen" class="col-md-4 col-sm-4 col-xs-4 download_block" @click="handler(3,'moyen',1,'moyen')">
        <p>Moyen <br /> <span>({{size_moyen}})</span></p>
      </div>
      <div id="petit" class="col-md-4 col-sm-4 col-xs-4 download_block" @click="handler(3,'petit',2,'petit')">
        <p>Petit <br /> <span>({{size_petit}})</span></p>
      </div>
    </div>
    
    <div class="download_pack">
      <h2>Votre pack à télécharger</h2>
      <h3>Dans votre pack :</h3> 
      <p><b>Formation(s) :</b> {{choix_formation}}</p> 
      <p><b>Couleur(s) :</b> {{choix_couleur}}</p> 
      <p><b>Support(s) :</b> {{choix_support}}</p> 
      <p><b>Taille(s) :</b> {{choix_taille}}</p> 

      <div class="col-md-12 col-sm-12 col-xs-12 download_block custom_dl" @click="triggerDownload()">
        <p>Télécharger votre pack !</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import JSZip from '../../node_modules/jszip/dist/jszip.min.js';
  import JSZipUtils from '../../node_modules/jszip/lib/jszip-utils.js';
  import saveAs from '../../node_modules/file-saver/FileSaver.min.js';

  export default {
    name: 'home',
    data () {
      return {
        is_active : false,
        is_hidden : true,
        image : "",
        ressources_array : ["LogoEsipeCustomPack/print/eisc_rvb_print_grand.eps","/static/ressources/eisc_rvb_print_grand.eps",
                            "LogoEsipeCustomPack/print/eisc_rvb_print_moyen.eps","/static/ressources/eisc_rvb_print_moyen.eps",
                            "LogoEsipeCustomPack/print/eisc_rvb_print_petit.eps","/static/ressources/eisc_rvb_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/eisc_rvb_numerique_grand.png","/static/ressources/eisc_rvb_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/eisc_rvb_numerique_moyen.png","/static/ressources/eisc_rvb_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/eisc_rvb_numerique_petit.png","/static/ressources/eisc_rvb_numerique_petit.png",
                            "LogoEsipeCustomPack/print/eisc_cmjn_print_grand.eps","/static/ressources/eisc_cmjn_print_grand.eps",
                            "LogoEsipeCustomPack/print/eisc_cmjn_print_moyen.eps","/static/ressources/eisc_cmjn_print_moyen.eps",
                            "LogoEsipeCustomPack/print/eisc_cmjn_print_petit.eps","/static/ressources/eisc_cmjn_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/eisc_cmjn_numerique_grand.png","/static/ressources/eisc_cmjn_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/eisc_cmjn_numerique_moyen.png","/static/ressources/eisc_cmjn_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/eisc_cmjn_numerique_petit.png","/static/ressources/eisc_cmjn_numerique_petit.png",
                            "LogoEsipeCustomPack/print/eisc_gris_print_grand.eps","/static/ressources/eisc_gris_print_grand.eps",
                            "LogoEsipeCustomPack/print/eisc_gris_print_moyen.eps","/static/ressources/eisc_gris_print_moyen.eps",
                            "LogoEsipeCustomPack/print/eisc_gris_print_petit.eps","/static/ressources/eisc_gris_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/eisc_gris_numerique_grand.png","/static/ressources/eisc_gris_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/eisc_gris_numerique_moyen.png","/static/ressources/eisc_gris_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/eisc_gris_numerique_petit.png","/static/ressources/eisc_gris_numerique_petit.png",
                            "LogoEsipeCustomPack/print/eisc_blanc_print_grand.eps","/static/ressources/eisc_blanc_print_grand.eps",
                            "LogoEsipeCustomPack/print/eisc_blanc_print_moyen.eps","/static/ressources/eisc_blanc_print_moyen.eps",
                            "LogoEsipeCustomPack/print/eisc_blanc_print_petit.eps","/static/ressources/eisc_blanc_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/eisc_blanc_numerique_grand.png","/static/ressources/eisc_blanc_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/eisc_blanc_numerique_moyen.png","/static/ressources/eisc_blanc_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/eisc_blanc_numerique_petit.png","/static/ressources/eisc_blanc_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gc_rvb_print_grand.eps","/static/ressources/gc_rvb_print_grand.eps",
                            "LogoEsipeCustomPack/print/gc_rvb_print_moyen.eps","/static/ressources/gc_rvb_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gc_rvb_print_petit.eps","/static/ressources/gc_rvb_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gc_rvb_numerique_grand.png","/static/ressources/gc_rvb_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gc_rvb_numerique_moyen.png","/static/ressources/gc_rvb_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gc_rvb_numerique_petit.png","/static/ressources/gc_rvb_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gc_cmjn_print_grand.eps","/static/ressources/gc_cmjn_print_grand.eps",
                            "LogoEsipeCustomPack/print/gc_cmjn_print_moyen.eps","/static/ressources/gc_cmjn_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gc_cmjn_print_petit.eps","/static/ressources/gc_cmjn_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gc_cmjn_numerique_grand.png","/static/ressources/gc_cmjn_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gc_cmjn_numerique_moyen.png","/static/ressources/gc_cmjn_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gc_cmjn_numerique_petit.png","/static/ressources/gc_cmjn_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gc_gris_print_grand.eps","/static/ressources/gc_gris_print_grand.eps",
                            "LogoEsipeCustomPack/print/gc_gris_print_moyen.eps","/static/ressources/gc_gris_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gc_gris_print_petit.eps","/static/ressources/gc_gris_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gc_gris_numerique_grand.png","/static/ressources/gc_gris_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gc_gris_numerique_moyen.png","/static/ressources/gc_gris_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gc_gris_numerique_petit.png","/static/ressources/gc_gris_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gc_blanc_print_grand.eps","/static/ressources/gc_blanc_print_grand.eps",
                            "LogoEsipeCustomPack/print/gc_blanc_print_moyen.eps","/static/ressources/gc_blanc_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gc_blanc_print_petit.eps","/static/ressources/gc_blanc_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gc_blanc_numerique_grand.png","/static/ressources/gc_blanc_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gc_blanc_numerique_moyen.png","/static/ressources/gc_blanc_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gc_blanc_numerique_petit.png","/static/ressources/gc_blanc_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gm_rvb_print_grand.eps","/static/ressources/gm_rvb_print_grand.eps",
                            "LogoEsipeCustomPack/print/gm_rvb_print_moyen.eps","/static/ressources/gm_rvb_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gm_rvb_print_petit.eps","/static/ressources/gm_rvb_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gm_rvb_numerique_grand.png","/static/ressources/gm_rvb_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gm_rvb_numerique_moyen.png","/static/ressources/gm_rvb_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gm_rvb_numerique_petit.png","/static/ressources/gm_rvb_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gm_cmjn_print_grand.eps","/static/ressources/gm_cmjn_print_grand.eps",
                            "LogoEsipeCustomPack/print/gm_cmjn_print_moyen.eps","/static/ressources/gm_cmjn_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gm_cmjn_print_petit.eps","/static/ressources/gm_cmjn_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gm_cmjn_numerique_grand.png","/static/ressources/gm_cmjn_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gm_cmjn_numerique_moyen.png","/static/ressources/gm_cmjn_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gm_cmjn_numerique_petit.png","/static/ressources/gm_cmjn_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gm_gris_print_grand.eps","/static/ressources/gm_gris_print_grand.eps",
                            "LogoEsipeCustomPack/print/gm_gris_print_moyen.eps","/static/ressources/gm_gris_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gm_gris_print_petit.eps","/static/ressources/gm_gris_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gm_gris_numerique_grand.png","/static/ressources/gm_gris_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gm_gris_numerique_moyen.png","/static/ressources/gm_gris_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gm_gris_numerique_petit.png","/static/ressources/gm_gris_numerique_petit.png",
                            "LogoEsipeCustomPack/print/gm_blanc_print_grand.eps","/static/ressources/gm_blanc_print_grand.eps",
                            "LogoEsipeCustomPack/print/gm_blanc_print_moyen.eps","/static/ressources/gm_blanc_print_moyen.eps",
                            "LogoEsipeCustomPack/print/gm_blanc_print_petit.eps","/static/ressources/gm_blanc_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/gm_blanc_numerique_grand.png","/static/ressources/gm_blanc_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/gm_blanc_numerique_moyen.png","/static/ressources/gm_blanc_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/gm_blanc_numerique_petit.png","/static/ressources/gm_blanc_numerique_petit.png",
                            "LogoEsipeCustomPack/print/imac_rvb_print_grand.eps","/static/ressources/imac_rvb_print_grand.eps",
                            "LogoEsipeCustomPack/print/imac_rvb_print_moyen.eps","/static/ressources/imac_rvb_print_moyen.eps",
                            "LogoEsipeCustomPack/print/imac_rvb_print_petit.eps","/static/ressources/imac_rvb_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/imac_rvb_numerique_grand.png","/static/ressources/imac_rvb_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/imac_rvb_numerique_moyen.png","/static/ressources/imac_rvb_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/imac_rvb_numerique_petit.png","/static/ressources/imac_rvb_numerique_petit.png",
                            "LogoEsipeCustomPack/print/imac_cmjn_print_grand.eps","/static/ressources/imac_cmjn_print_grand.eps",
                            "LogoEsipeCustomPack/print/imac_cmjn_print_moyen.eps","/static/ressources/imac_cmjn_print_moyen.eps",
                            "LogoEsipeCustomPack/print/imac_cmjn_print_petit.eps","/static/ressources/imac_cmjn_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/imac_cmjn_numerique_grand.png","/static/ressources/imac_cmjn_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/imac_cmjn_numerique_moyen.png","/static/ressources/imac_cmjn_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/imac_cmjn_numerique_petit.png","/static/ressources/imac_cmjn_numerique_petit.png",
                            "LogoEsipeCustomPack/print/imac_gris_print_grand.eps","/static/ressources/imac_gris_print_grand.eps",
                            "LogoEsipeCustomPack/print/imac_gris_print_moyen.eps","/static/ressources/imac_gris_print_moyen.eps",
                            "LogoEsipeCustomPack/print/imac_gris_print_petit.eps","/static/ressources/imac_gris_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/imac_gris_numerique_grand.png","/static/ressources/imac_gris_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/imac_gris_numerique_moyen.png","/static/ressources/imac_gris_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/imac_gris_numerique_petit.png","/static/ressources/imac_gris_numerique_petit.png",
                            "LogoEsipeCustomPack/print/imac_blanc_print_grand.eps","/static/ressources/imac_blanc_print_grand.eps",
                            "LogoEsipeCustomPack/print/imac_blanc_print_moyen.eps","/static/ressources/imac_blanc_print_moyen.eps",
                            "LogoEsipeCustomPack/print/imac_blanc_print_petit.eps","/static/ressources/imac_blanc_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/imac_blanc_numerique_grand.png","/static/ressources/imac_blanc_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/imac_blanc_numerique_moyen.png","/static/ressources/imac_blanc_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/imac_blanc_numerique_petit.png","/static/ressources/imac_blanc_numerique_petit.png",
                            "LogoEsipeCustomPack/print/info_rvb_print_grand.eps","/static/ressources/info_rvb_print_grand.eps",
                            "LogoEsipeCustomPack/print/info_rvb_print_moyen.eps","/static/ressources/info_rvb_print_moyen.eps",
                            "LogoEsipeCustomPack/print/info_rvb_print_petit.eps","/static/ressources/info_rvb_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/info_rvb_numerique_grand.png","/static/ressources/info_rvb_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/info_rvb_numerique_moyen.png","/static/ressources/info_rvb_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/info_rvb_numerique_petit.png","/static/ressources/info_rvb_numerique_petit.png",
                            "LogoEsipeCustomPack/print/info_cmjn_print_grand.eps","/static/ressources/info_cmjn_print_grand.eps",
                            "LogoEsipeCustomPack/print/info_cmjn_print_moyen.eps","/static/ressources/info_cmjn_print_moyen.eps",
                            "LogoEsipeCustomPack/print/info_cmjn_print_petit.eps","/static/ressources/info_cmjn_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/info_cmjn_numerique_grand.png","/static/ressources/info_cmjn_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/info_cmjn_numerique_moyen.png","/static/ressources/info_cmjn_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/info_cmjn_numerique_petit.png","/static/ressources/info_cmjn_numerique_petit.png",
                            "LogoEsipeCustomPack/print/info_gris_print_grand.eps","/static/ressources/info_gris_print_grand.eps",
                            "LogoEsipeCustomPack/print/info_gris_print_moyen.eps","/static/ressources/info_gris_print_moyen.eps",
                            "LogoEsipeCustomPack/print/info_gris_print_petit.eps","/static/ressources/info_gris_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/info_gris_numerique_grand.png","/static/ressources/info_gris_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/info_gris_numerique_moyen.png","/static/ressources/info_gris_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/info_gris_numerique_petit.png","/static/ressources/info_gris_numerique_petit.png",
                            "LogoEsipeCustomPack/print/info_blanc_print_grand.eps","/static/ressources/info_blanc_print_grand.eps",
                            "LogoEsipeCustomPack/print/info_blanc_print_moyen.eps","/static/ressources/info_blanc_print_moyen.eps",
                            "LogoEsipeCustomPack/print/info_blanc_print_petit.eps","/static/ressources/info_blanc_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/info_blanc_numerique_grand.png","/static/ressources/info_blanc_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/info_blanc_numerique_moyen.png","/static/ressources/info_blanc_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/info_blanc_numerique_petit.png","/static/ressources/info_blanc_numerique_petit.png",
                            "LogoEsipeCustomPack/print/mfpi_rvb_print_grand.eps","/static/ressources/mfpi_rvb_print_grand.eps",
                            "LogoEsipeCustomPack/print/mfpi_rvb_print_moyen.eps","/static/ressources/mfpi_rvb_print_moyen.eps",
                            "LogoEsipeCustomPack/print/mfpi_rvb_print_petit.eps","/static/ressources/mfpi_rvb_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/mfpi_rvb_numerique_grand.png","/static/ressources/mfpi_rvb_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/mfpi_rvb_numerique_moyen.png","/static/ressources/mfpi_rvb_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/mfpi_rvb_numerique_petit.png","/static/ressources/mfpi_rvb_numerique_petit.png",
                            "LogoEsipeCustomPack/print/mfpi_cmjn_print_grand.eps","/static/ressources/mfpi_cmjn_print_grand.eps",
                            "LogoEsipeCustomPack/print/mfpi_cmjn_print_moyen.eps","/static/ressources/mfpi_cmjn_print_moyen.eps",
                            "LogoEsipeCustomPack/print/mfpi_cmjn_print_petit.eps","/static/ressources/mfpi_cmjn_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/mfpi_cmjn_numerique_grand.png","/static/ressources/mfpi_cmjn_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/mfpi_cmjn_numerique_moyen.png","/static/ressources/mfpi_cmjn_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/mfpi_cmjn_numerique_petit.png","/static/ressources/mfpi_cmjn_numerique_petit.png",
                            "LogoEsipeCustomPack/print/mfpi_gris_print_grand.eps","/static/ressources/mfpi_gris_print_grand.eps",
                            "LogoEsipeCustomPack/print/mfpi_gris_print_moyen.eps","/static/ressources/mfpi_gris_print_moyen.eps",
                            "LogoEsipeCustomPack/print/mfpi_gris_print_petit.eps","/static/ressources/mfpi_gris_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/mfpi_gris_numerique_grand.png","/static/ressources/mfpi_gris_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/mfpi_gris_numerique_moyen.png","/static/ressources/mfpi_gris_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/mfpi_gris_numerique_petit.png","/static/ressources/mfpi_gris_numerique_petit.png",
                            "LogoEsipeCustomPack/print/mfpi_blanc_print_grand.eps","/static/ressources/mfpi_blanc_print_grand.eps",
                            "LogoEsipeCustomPack/print/mfpi_blanc_print_moyen.eps","/static/ressources/mfpi_blanc_print_moyen.eps",
                            "LogoEsipeCustomPack/print/mfpi_blanc_print_petit.eps","/static/ressources/mfpi_blanc_print_petit.eps",
                            "LogoEsipeCustomPack/numerique/mfpi_blanc_numerique_grand.png","/static/ressources/mfpi_blanc_numerique_grand.png",
                            "LogoEsipeCustomPack/numerique/mfpi_blanc_numerique_moyen.png","/static/ressources/mfpi_blanc_numerique_moyen.png",
                            "LogoEsipeCustomPack/numerique/mfpi_blanc_numerique_petit.png","/static/ressources/mfpi_blanc_numerique_petit.png"                                              
                           ],
        formation_array : ["","","","","",""],
        couleur_array : ["","","","","",""],
        support_array : ["","","","","",""],
        taille_array : ["","","","","",""],
        size_grand : "210mm*297mm & 2048px*2048px",
        size_moyen : "105mm*148mm & 1024px*1024px",
        size_petit : "52mm*75mm & 512px*512px",
        choix_formation : "Toutes les formations",
        choix_couleur : "Toutes les couleurs",
        choix_support : "Tous les supports",
        choix_taille : "Toutes les tailles"
      }
    },
    methods: {
      toggleActive(id){
        var d = document.getElementById(id);        
        d.classList.toggle("isactive");
      },
      toggleHidden(string){
        var b = document.getElementById("overflow");
        console.log(b);
        this.is_hidden = !this.is_hidden;
        if(this.is_hidden == true){
          b.style.overflow = 'visible';
        } else {
          b.style.overflow = 'hidden';
        }
        this.image = string;
        return this.is_hidden;
      },
      isEmpty(array){
        var zero_count = 0;
        for(var i = 0; i < array.length; i++){
          if(array[i] == "0"){
            zero_count++
          }
        }
        if(zero_count == array.length){
          return true;
        } else {
          return false;
        }
      },
      editFormationArray(value, string){
        for (var i = 0; i < this.formation_array.length; i++) {
          if (i == value){
            if(this.formation_array[i] == "" || this.formation_array[i] == "0") {
              this.formation_array[i] = string;  
            } else {
              this.formation_array[i] = "0";
            }
          } else if (this.formation_array[i] == "") {
            this.formation_array[i] = "0"; 
          }
        }
        if(this.isEmpty(this.formation_array)){
          for (var i = 0; i < this.formation_array.length; i++) {
            this.formation_array[i] = "";
          }       
          this.choix_formation = "Toutes les formations"
        } else {
          this.choix_formation = ""
          for (var i = 0; i < this.formation_array.length; i++) {
            if(this.formation_array[i] != "0"){
              this.choix_formation += this.formation_array[i]+"  ";
            }
          }
        }
        return this.formation_array;
      },
      editCouleurArray(value, string){
        for (var i = 0; i < this.couleur_array.length; i++) {
          if (i == value){
            if(this.couleur_array[i] == "" || this.couleur_array[i] == "0") {
              this.couleur_array[i] = string;  
            } else {
              this.couleur_array[i] = "0";
            }
          } else if (this.couleur_array[i] == "") {
            this.couleur_array[i] = "0"; 
          }
        }
        if(this.isEmpty(this.couleur_array)){
          for (var i = 0; i < this.couleur_array.length; i++) {
            this.couleur_array[i] = ""; 
          }
          this.choix_couleur = "Toutes les couleurs"       
        } else {
          this.choix_couleur = ""
          for (var i = 0; i < this.couleur_array.length; i++) {
            if(this.couleur_array[i] != "0"){
              this.choix_couleur += this.couleur_array[i]+"  ";
            }
          }
        }  
        return this.couleur_array;
      },
      editSupportArray(value, string){
        for (var i = 0; i < this.support_array.length; i++) {
          if (i == value){
            if(this.support_array[i] == "" || this.support_array[i] == "0") {
              this.support_array[i] = string;  
            } else {
              this.support_array[i] = "0";
            }
          } else if (this.support_array[i] == "") {
            this.support_array[i] = "0"; 
          }
        }
        if(this.isEmpty(this.support_array)){
          for (var i = 0; i < this.support_array.length; i++) {
            this.support_array[i] = ""; 
          }       
          this.choix_support = "Tous les supports"
        } else {
          this.choix_support = ""
          for (var i = 0; i < this.support_array.length; i++) {
            if(this.support_array[i] != "0"){
              this.choix_support += this.support_array[i]+"  ";
            }
          }
        }  
        if(this.support_array[0] == "print" && this.support_array[1] == "0") {
          this.size_grand = "210mm*297mm";
          this.size_moyen = "105mm*148mm";
          this.size_petit = "52mm*75mm";
        } else if(this.support_array[0] == "0" && this.support_array[1] == "numerique") {
          this.size_grand = "2048px*2048px";
          this.size_moyen = "1024px*1024px";
          this.size_petit = "512px*512px";
        } else if(this.support_array[0] == "print" && this.support_array[1] == "numerique") {
          this.size_grand = "210mm*297mm & 2048px*2048px";
          this.size_moyen = "105mm*148mm & 1024px*1024px";
          this.size_petit = "52mm*75mm & 512px*512px";
        } else if(this.support_array[0] == "" && this.support_array[1] == "") {
          this.size_grand = "210mm*297mm & 2048px*2048px";
          this.size_moyen = "105mm*148mm & 1024px*1024px";
          this.size_petit = "52mm*75mm & 512px*512px";
        }
        return this.support_array;
      },
      editTailleArray(value, string){
        for (var i = 0; i < this.taille_array.length; i++) {
          if (i == value){
            if(this.taille_array[i] == "" || this.taille_array[i] == "0") {
              this.taille_array[i] = string;  
            } else {
              this.taille_array[i] = "0";
            }
          } else if (this.taille_array[i] == "") {
            this.taille_array[i] = "0"; 
          }
        }
        if(this.isEmpty(this.taille_array)){
          for (var i = 0; i < this.taille_array.length; i++) {
            this.taille_array[i] = "";             
          }
          this.choix_taille = "Toutes les tailles"       
        } else {
          this.choix_taille = ""
          for (var i = 0; i < this.taille_array.length; i++) {
            if(this.taille_array[i] != "0"){
              this.choix_taille += this.taille_array[i]+"  ";
            }
          }
        }  
        return this.taille_array;
      },
      handler(array, id, value, string){
        this.toggleActive(id);
        if(array == 0) {
          this.editFormationArray(value, string)
        } else if (array == 1) {
          this.editCouleurArray(value, string)
        } else if (array == 2) {
          this.editSupportArray(value, string)
        } else if (array == 3) {
          this.editTailleArray(value, string)
        }

        console.log("formation " + this.formation_array)
        console.log("couleur " + this.couleur_array)
        console.log("support " + this.support_array)
        console.log("taille " + this.taille_array)
      },
      triggerDownload () {
        var zip = new JSZip();
        var zipArray = [];
        var zero_count = 0;

        for(var i = 0; i < this.ressources_array.length; i = i+2){
          for(var k = 0; k < this.formation_array.length; k++){
            if(this.ressources_array[i].toLowerCase().indexOf(this.formation_array[k]) !== -1){
              for(var k = 0; k < this.couleur_array.length; k++){
                if(this.ressources_array[i].toLowerCase().indexOf(this.couleur_array[k]) !== -1){
                  for(var k = 0; k < this.support_array.length; k++){
                    if(this.ressources_array[i].toLowerCase().indexOf(this.support_array[k]) !== -1){
                      for(var k = 0; k < this.taille_array.length; k++){
                        if(this.ressources_array[i].toLowerCase().indexOf(this.taille_array[k]) !== -1){
                          zipArray.push(this.ressources_array[i], this.ressources_array[i+1]);
                        }
                      }
                    }
                  }
                }
              }
            }  
          }
        }  
        function urlToPromise(url) {
          return new Promise(function(resolve, reject) {
            JSZipUtils.getBinaryContent(url, function (err, data) {
              if(err) {
                reject(err);
              } else {
                resolve(data);
              }
            });
          });
        }

        var filename = "";
        var url = "";

        for(var i = 0; i < zipArray.length-1; i = i+2) {
          filename = zipArray[i];
          url = zipArray[i+1];
          zip.file(filename, urlToPromise(url), {binary:true});
        }

        zip.generateAsync({type:"blob"})
        .then(function (blob) {
          saveAs.saveAs(blob, "LogosEsipeCustomPack.zip");
        });
      }
    }
  }
</script>
<style lang="scss">

  /*FONTS
  **
  */
  @font-face {
    font-family: 'Poppins-Regular';
    src: url('../assets/fonts/Poppins-Regular.ttf');
  }

  .hidden{display: none;}

  .home h1, 
  .home h2, 
  .home h3, 
  .home p,  {font-family: 'Poppins-Regular';}

 .home h1{
    margin-bottom: 40px ;
  }

  @media screen and (max-width: 410px){
    .home h1{
      font-size: 20px;
      margin-bottom: 20px ;
    }  
  }

  .home h2{
    font-size: 32px;
    margin-bottom: 20px ;
  }

  @media screen and (max-width: 410px){
    .home h2{
      font-size: 18px;
      margin-bottom: 10px ;
    }  
  }

  .home h3{
    font-size: 28px;
    margin-bottom: 10px ;
  }

  @media screen and (max-width: 410px){
    .home h3{
      font-size: 14px;
    }  
  }

  .home p{
    font-size: 16px;
    margin-bottom: 10px ;
  }

  @media screen and (max-width: 768px){
    .home p{
      font-size: 14px;
    }  
  }

  @media screen and (max-width: 410px){
    .home p{
      font-size: 12px;
    }  
  }

  .home{ background-image: url("../assets/bkg/gplaypattern.png"); }

  .home_content{ background: rgba(255,255,255,0.4); }

  .banner {margin-bottom: 60px;}

  @media screen and (max-width: 410px){
    .banner {margin-bottom: 20px;} 
  }

  .banner img{
    cursor: pointer;
    width: 100%;
  }
  @media screen and (max-width: 768px){
    .banner img{margin-bottom: 20px;} 
  }

  .popup{
    position: absolute;
    top:0;
    left: 0;
    z-index: 100;
    height: 100vh;
    width: 100%;
    background-color: rgba(255,255,255,0.8);
    cursor: pointer;
  }

  .popup_content {
    margin-top: 50vh;
    transform: translateY(-50%);
  }

  .popup img {
    height: 300px;
    display: block;
    margin: 0 auto;
  }

  .popup p {
    margin-top: 20px;
    color: #000;
    text-align: center;
  }

  .pack{ height: 300px; }

  @media screen and (max-width: 410px){
    .pack{ height: 320px; }  
  }

  .pack i{ margin: 20px 0; }

  .download_block {
    background-color: #ccc;
    text-align:center;
    cursor:pointer;
    padding-top: 10px;
    margin-bottom: 20px;

    &:hover {
      background-color: #ffe680;
      transition : background-color.5s;
    }

  }

  @media screen and (max-width: 768px){
    .custom > .download_block { height: 50px; }
    .download_block span { display: none; }
  }

  .custom_dl { padding: 10px 0; }

  .custom_dl p { 
    padding-top: 10px;
    font-size: 24px 
  }

  @media screen and (max-width: 410px){
    .custom_dl p { 
      font-size: 18px 
    }
  }

  .isactive{ background-color: #ffcc00; }

  .isactive:hover{ background-color: #ffcc00; }

  .pack { margin-bottom: 50px; }
  .custom { margin-bottom: 100px; }
</style>



// WEBPACK FOOTER //
// Ressources.vue?13cb9857